import { useMemo } from 'react';
import SearchParams from '../constants/SearchParams';
import useUrlQueryParams from './useUrlQueryParams';

/**
 * Url params are used to track the request state in oauth flows as well as notification requests.
 * These values are passed through to the server in POST requests.
 * @return {{requestId: string || boolean, notificationToken: string || boolean}}
 */
const useRequestState = () => {
    const searchParams = useUrlQueryParams();
    const requestState = useMemo(() => {
        const requestParams = {};
        const requestId = searchParams?.get(SearchParams.REQUEST_ID);
        const notificationToken = searchParams?.get(SearchParams.NOTIFICATION_TOKEN);
        if (requestId) {
            requestParams.requestId = requestId;
        }
        if (notificationToken) {
            requestParams.notificationToken = notificationToken;
        }
        return requestParams;
    }, [searchParams]);

    return requestState;
};

export default useRequestState;
